import { useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";

export const K8SIndexPage = ({to}) => {
  const { id } = useParams();
  const nav = useNavigate();
  
  useEffect(() => {
    nav(`/k8s/${id}/${to}`);
  }, nav);
  return null;
};